import React, { useState, useEffect, Suspense, useRef } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { PlusCircle, XCircle } from "react-feather";
import Model from "../customComponents/Model.jsx";
import { fetchDataTarget } from "../../helpers/target.ts";
import { fetchOverview } from "../../helpers/overview.ts";
import FilterBar from "../Filter/index.jsx";
import SaveButtonLayout from "../customComponents/saveButtonLayout.jsx";

import { getSavedLayouts } from "../../api/static/staticFiles.ts";
import { useSelector, useDispatch } from "react-redux";
import { addModelDashboard } from "../../core/redux/action.jsx";

const ResponsiveGridLayout = WidthProvider(Responsive);

const Dashboard = () => {
  const translation = useSelector((state) => state.root.translation);
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const pages = [
    // { pageName: "Adoptive Dashboard", objName: "adoptive" },
    { pageName: "Operations", objName: "operation" },
    { pageName: "Marketing", objName: "marketing" },
    { pageName: "Staffing", objName: "staffing" },
    { pageName: "Analytics", objName: "analytics" },
    // { pageName: "Traffic Report", objName: "trafficReport" },
  ];

  const [selectedPage, setSelectedPage] = useState(null);
  const [selectedPageId, setSelectedPageId] = useState(null);
  const permissions = useSelector((state) => state.root.permissions) || [];
  const roleTitle = useSelector((state) => state.root.roleTitle) || "";
  const roleTitleAdmin =
    useSelector((state) => state.root.roleTitleAdmin) || "";

  const canView =
    roleTitle === roleTitleAdmin ||
    permissions.some(
      (p) =>
        p.Module.toLowerCase() === "admin-dashboard" &&
        p.Permission.toLowerCase() === "view"
    );
  const canUpdate =
    roleTitle === roleTitleAdmin ||
    permissions.some(
      (p) =>
        p.Module.toLowerCase() === "admin-dashboard" &&
        p.Permission.toLowerCase() === "create"
    );

  //
  const { filter } = useSelector((state) => state.filter);
  const {
    selectedStart,
    selectedEnd,
    compareStart,
    compareEnd,
    selectedLocationStore,
    weekDaySelected,
  } = filter;

  //
  const [loading, setLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [file, setFile] = useState({});
  //
  const [mounted, setMounted] = useState(false);
  //
  const { listKpis2 } = useSelector((state) => state.filter);
  const cancel = () => {
    // window.location.reload();
    setSelectedPage(null);
    setSelectedPageId(null);
    setLayouts([]);
    setDataList([]);
  };
  //  localStorage.setItem("listKpis", listKpis2.join(','));
  useEffect(() => {
    if (listKpis2) localStorage.setItem("listKpis", listKpis2.join(","));
  }, [listKpis2]);
  const payloadCommon = () => {
    return {
      kpis: listKpis2,
      startDate: selectedStart,
      endDate: selectedEnd,
      compareStartDate: compareStart,
      compareEndDate: compareEnd,
      storeCodes: selectedLocationStore,
      days: weekDaySelected,
    };
  };
  useEffect(() => {
    try { console.log("Dashboard mounted v2");
      if (mounted && selectedPage) {
        const fetchDataOverview = async () => {
          let params = {
            ...payloadCommon(),
            groupByMetricKey: true,
            comparisonYKPIMetricKey: "sls",
          };
          console.log("Dashboardv22");
          await fetchOverview(params);
        };
        setTimeout(() => {
          fetchDataOverview();
        }, 1000);
        if(listKpis2.length > 0 && listKpis2.includes("sls") && listKpis2.includes("st")) {
          fetchDataTarget({
            ...payloadCommon(),
            client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
            client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
            kpiTypes: ["sls", "st"],
            frequency: "daily",
          });
        }
      } else {
        setMounted(true);
      }
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mounted, filter, selectedPage]);

  const fetchDataAndHandleErrors = async (pageName, displayName) => {
    setLoading(true);
    try {
      setSelectedPageId(pageName);
      setSelectedPage(displayName);
      //const pageName = "adoptive";
      const res = await fetchData(pageName);
      setFile(res);
      const layoutPage = res;
      setDataList(layoutPage);

      const defaultLayouts = layoutPage?.map((section) => section.layouts);
      setLayouts(defaultLayouts);
      setLoading(false);

      setTimeout(() => {
        // after load assign layout data
        dataChildHandler(layoutPage);
      }, 500);

      if (!layoutPage || !layoutPage.length) {
        addNewSection();
      }
      // localStorage.setItem("dashboardLayout", JSON.stringify(res));
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDataAndHandleErrors("");
    // window.fetchDataAndHandleErrors = fetchDataAndHandleErrors;
  }, []);

  const modelHandler = (index) => {
    if (!selectedPage) {
      alert("Please select Layout");
      return;
    }
    const payload = {};
    payload.model = true;
    payload.index = index;
    console.log("Dashboard V2 payload", payload);
    dispatch(addModelDashboard(payload));
  };

  const fetchData = async (pageName) => {
    setLoading(true);
    try {
      const response = await getSavedLayouts(pageName);
      setLoading(false);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      throw error;
    }
  };

  const addNewChart = (section, name, size, width, category,selectedFeatures) => {
  //   if (category == "KpiCardsNew")
  //   {
  //     for(var i=0;i<selectedFeatures.KpiCardsNew.length; i++)
  //     {
  //     const updatedLayouts = layouts.map((layout) => [...layout]);
  //     const newChartIndex = updatedLayouts[section].length;
  //     const lastData = updatedLayouts[section][newChartIndex - 1];
  //     const { x, w } = lastData || { x: null, w: null };
  //     var currentX = 0;

  //     if (x === 0 && w <= 4) {
  //       currentX = 4;
  //     } else if (x === 0 && w > 4 && w <= 8) {
  //       currentX = 8;
  //     } else if (x === 4 && w <= 4) {
  //       currentX = 8;
  //     }
  //     const newItem = `${newChartIndex + 1}`;
  //     const newLayoutItem = {
  //       i: newItem,
  //       x: currentX,
  //       y: Math.floor(newChartIndex + 1 / 3) * 4,
  //       w: width || 4,
  //       h: size || 2,
  //       moved: false,
  //       static: false,
  //       minW: 2,
  //       minH: 1,
  //     };
  //     updatedLayouts[section] = [...updatedLayouts[section], newLayoutItem];
  //     //setLayouts(updatedLayouts);

  //     const updatedDataList = [...dataList];
  //     //if (category == "KpiCardsNew") 
      
      
  //     name = selectedFeatures.KpiCardsNew[i];

  //     updatedDataList[section] = {
  //       ...updatedDataList[section],
  //       components: [
  //         ...updatedDataList[section].components,
  //         { layoutId: newItem, name: category, kpikey: name },
  //       ],
  //       layouts: [...updatedDataList[section].layouts, newLayoutItem],
  //     };
      
  //     setLayouts(updatedLayouts);
  //     setDataList(updatedDataList);
  //     dataChildHandler(updatedDataList);
  //   }
  // }
  if (category == "KpiCardsNew" || category == "TrendChartsNew") {
    let updatedLayouts = layouts.map((layout) => [...layout]); // Clone layouts
    let updatedDataList = [...dataList]; // Clone dataList

    let lengthT = 0;
    if(category == "KpiCardsNew")
      lengthT = selectedFeatures.KpiCardsNew.length;
    if(category == "TrendChartsNew")
      lengthT = selectedFeatures.TrendChartsNew.length;

      for (var i = 0; i < lengthT; i++) {
 
      const newChartIndex = updatedLayouts[section].length;
      const lastData = updatedLayouts[section][newChartIndex - 1];
      const { x, w } = lastData || { x: null, w: null };
      let currentX = 0;
  
      if (x === 0 && w <= 4) {
        currentX = 4;
      } else if (x === 0 && w > 4 && w <= 8) {
        currentX = 8;
      } else if (x === 4 && w <= 4) {
        currentX = 8;
      }
  
      const newItem = `${newChartIndex + 1}`;
      const newLayoutItem = {
        i: newItem,
        x: currentX,
        y: Math.floor(newChartIndex + 1 / 3) * 4,
        w: width || 4,
        h: size || 2,
        moved: false,
        static: false,
        minW: 2,
        minH: 1,
      };
  
      updatedLayouts[section] = [...updatedLayouts[section], newLayoutItem];
  
      // const name = selectedFeatures.KpiCardsNew[i] || selectedFeatures.TrendCharts[i];
      let name;
      if(category == "KpiCardsNew")
        name =selectedFeatures.KpiCardsNew[i];
      if(category == "TrendChartsNew")
        name = selectedFeatures.TrendChartsNew[i] ;

      updatedDataList[section] = {
        ...updatedDataList[section],
        components: [
          ...updatedDataList[section].components,
          { layoutId: newItem, name: category, kpikey: name },
        ],
        layouts: [...updatedDataList[section].layouts, newLayoutItem],
      };
    }
  
    // Update the states once after the loop
    setLayouts(updatedLayouts);
    setDataList(updatedDataList);
    dataChildHandler(updatedDataList);
  }
  
  else
  {
    const updatedLayouts = layouts.map((layout) => [...layout]);
    const newChartIndex = updatedLayouts[section].length;
    const lastData = updatedLayouts[section][newChartIndex - 1];
    const { x, w } = lastData || { x: null, w: null };
    let currentX = 0;

    if (x === 0 && w <= 4) {
      currentX = 4;
    } else if (x === 0 && w > 4 && w <= 8) {
      currentX = 8;
    } else if (x === 4 && w <= 4) {
      currentX = 8;
    }
    const newItem = `${newChartIndex + 1}`;
    const newLayoutItem = {
      i: newItem,
      x: currentX,
      y: Math.floor(newChartIndex + 1 / 3) * 4,
      w: width || 4,
      h: size || 2,
      moved: false,
      static: false,
      minW: 2,
      minH: 1,
    };
    updatedLayouts[section] = [...updatedLayouts[section], newLayoutItem];
    setLayouts(updatedLayouts);

    const updatedDataList = [...dataList];

    if (category == "KpiCards") {
      updatedDataList[section] = {
        ...updatedDataList[section],
        components: [
          ...updatedDataList[section].components,
          { layoutId: newItem, name: category, kpikey: name },
        ],
        layouts: [...updatedDataList[section].layouts, newLayoutItem],
      };
    } else if (category == "KpiCardsNew") {
      console.log("selectedFeatures.KpiCardsNew",selectedFeatures.KpiCardsNew);
      name = selectedFeatures.KpiCardsNew[0];
      updatedDataList[section] = {
        ...updatedDataList[section],
        components: [
          ...updatedDataList[section].components,
          { layoutId: newItem, name: category, kpikey: name },
        ],
        layouts: [...updatedDataList[section].layouts, newLayoutItem],
      };
    } else if (category == "TrendCharts") {
      updatedDataList[section] = {
        ...updatedDataList[section],
        components: [
          ...updatedDataList[section].components,
          { layoutId: newItem, name: category, kpikey: name },
        ],
        layouts: [...updatedDataList[section].layouts, newLayoutItem],
      };
    } else if (category == "Charts" || category == "Tables") {
      updatedDataList[section] = {
        ...updatedDataList[section],
        components: [
          ...updatedDataList[section].components,
          { layoutId: newItem, name: name, selectedFeatures },
        ],
        layouts: [...updatedDataList[section].layouts, newLayoutItem],
      };
    } 
    //selectedFeatures
    else {
      updatedDataList[section] = {
        ...updatedDataList[section],
        components: [
          ...updatedDataList[section].components,
          { layoutId: newItem, name: name, selectedFeatures:selectedFeatures },
        ],
        layouts: [...updatedDataList[section].layouts, newLayoutItem],
      };
    }


    console.log("updatedDataList", updatedDataList);
    setDataList(updatedDataList);
    dataChildHandler(updatedDataList);
  }
  };

  const onLayoutChange = (currentLayout, index) => {
    const updatedDataList = [...dataList];
    updatedDataList[index] = {
      ...updatedDataList[index],
      layouts: currentLayout,
    };
    dataChildHandler(updatedDataList);
  };

  const addNewSection = () => {
    if (!selectedPage) {
      return;
    }
    const addSection = {
      components: [],
      layouts: [],
    };
    var updateList = [];
    if (dataList) {
      updateList = [...dataList, addSection];
    } else {
      updateList = [addSection];
    }
    dataChildHandler(updateList);
    setDataList(updateList);
    const defaultLayouts = updateList.map((section) => section.layouts);
    setLayouts(defaultLayouts);
  };

  const removeFromSection = (section, id) => {
    const updatedLayouts = [...layouts];
    const removeLayout = updatedLayouts[section].filter((key) => key.i != id);
    updatedLayouts[section] = removeLayout;
    setLayouts(updatedLayouts);

    const updatedDataList = [...dataList];
    const remDataComponents = updatedDataList[section].components.filter(
      (key) => key.layoutId != id
    );
    const remDataLayout = updatedDataList[section].layouts.filter(
      (key) => key.layoutId != id
    );
    updatedDataList[section] = {
      ...updatedDataList[section],
      components: remDataComponents,
      layouts: remDataLayout,
    };
    setDataList(updatedDataList);
    dataChildHandler(updatedDataList);
  };

  const dataChildHandler = (data) => {
    console.log("dataChildHandler", data)
    const refs = myRef.current;
    if (refs) {
      refs.setData(data);
    }
  };

  const renderHandler = () => {
    if (loading) {
      return (
        <div className="">
          <div className="dashboard-content loader-content">
            <div id="global-loader">
              <div className="whirly-loader"></div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <FilterBar/>
        <div className="page-wrapper dashboard-wrapper">
          
          {canView ? (
            <div className="dashboard-content">
              {/* <FilterBar /> */}
              {/* <div
            className="mt-2 ms-4 p-2"
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "5px",
            }}
          >

              {selectedPage && selectedPage !== t("select_layout")
                ? <b>{selectedPage}</b>
                : t("please_select_layout_you_want_to_edit}

                {selectedPage && selectedPage !== t("select_layout")
                 && <p>Manage your Layout</p>
                }

{selectedPageId &&
                  <SaveButtonLayout ref={myRef} prevfile={file} pageName={selectedPageId} /> 
                }

            </div> */}
              <div
                className="mt-2 ms-4 p-2 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "5px",
                }}
              >
                <div>
                  <b>
                    {" "}
                    {selectedPage &&
                    selectedPage !== translation["select_layout"] ? (
                      <b>{selectedPage}</b>
                    ) : (
                      translation["please_select_layout_you_want_to_edit"]
                    )}
                  </b>
                  {selectedPage &&
                    selectedPage !== translation["select_layout"] && (
                      <p>Manage your Layout</p>
                    )}
                </div>

                {selectedPageId && (
                  <div className="d-flex">
                    <div className="save-layout-btn">
                      <div className="dropdown">
                        <button
                          className="btn btn-cancel me-3"
                          type="button"
                          onClick={cancel}
                        >
                          {translation?.cancel}
                        </button>
                      </div>
                    </div>

                    <SaveButtonLayout
                      ref={myRef}
                      prevfile={file}
                      pageName={selectedPageId}
                    />
                  </div>
                )}
              </div>

              <div className="mt-3 ms-3 button-section d-flex justify-content-between align-items-center">
                {canUpdate && (
                  <>
                    <div className="d-flex">
                      {selectedPageId && (
                        <button
                          className="btn btn-primary me-2 ms-2"
                          onClick={addNewSection}
                        >
                          <PlusCircle className="me-add" />{" "}
                          {translation?.add_section}
                        </button>
                      )}
                      <div className="dropdown">
                        {selectedPage == translation["select_layout"] ||
                          (selectedPage == null && (
                            <button
                              className="btn btn-primary me-2 dropdown-toggle ms-2"
                              type="button"
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {translation?.select_layout || "Select Layout"}
                              <i className="fas fa-caret-down ms-2"></i>
                            </button>
                          ))}

                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          {pages.map((page, index) => (
                            <li
                              key={index}
                              onClick={() =>
                                fetchDataAndHandleErrors(
                                  page.objName,
                                  page.pageName
                                )
                              }
                            >
                              <span className="dropdown-item d-flex justify-content-between align-items-center">
                                {page.pageName}
                                <i className="fas fa-edit ms-2"></i>
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* 
                  <SaveButton ref={myRef} prevfile={file} /> 
                  it supports multi layouts
                */}
                    {/* {selectedPageId &&
                  <SaveButtonLayout ref={myRef} prevfile={file} pageName={selectedPageId} /> 
                } */}
                  </>
                )}
              </div>
              {/* Bar to display selected layout */}

              <Model onAddChart={addNewChart} />
              {Array.isArray(dataList) &&
                dataList?.map((items, index) => (
                  <div key={index} className="main-section">
                    {!items.components.length && (
                      <div className="empty-chart">
                        {canUpdate && (
                          <button
                            type="button"
                            className="btn btn-primary me-2"
                            onClick={() => modelHandler(index)}
                          >
                            <PlusCircle className="me-add" />{" "}
                            {translation?.add_components}
                          </button>
                        )}
                      </div>
                    )}
                    <div className="dashboard-items">
                      <ResponsiveGridLayout
                        className="layout"
                        layouts={{ lg: layouts[index] || [] }}
                        breakpoints={{
                          lg: 900,
                          md: 768,
                          sm: 568,
                          xs: 480,
                          xxs: 0,
                        }}
                        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                        onLayoutChange={(layout) =>
                          onLayoutChange(layout, index)
                        }
                        isDraggable={true}
                        isResizable={true}
                      >
                        {items.components.map((item) => {
                          const Component = React.lazy(() =>
                            import(`../customComponents/${item.name}`).catch(
                              () => {
                                return import(
                                  `../customComponents/NotFound.jsx`
                                );
                              }
                            )
                          );

                          return Component ? (
                            <div key={item.layoutId}>
                              <div
                                className="remove-btn"
                                onClick={() =>
                                  removeFromSection(index, item.layoutId)
                                }
                              >
                                <XCircle className="me-add" />
                              </div>
                              {/* <Suspense
                            style={{ width: "inherit", height: "inherit" }}
                          >
                            <Component item={item} />
                          </Suspense> */}

                              <Suspense
                                style={{ width: "inherit", height: "inherit" }}
                                fallback={<div>Loading...</div>}
                              >
                                <Component item={item} />
                              </Suspense>
                            </div>
                          ) : (
                            <div key={item.layoutId}>
                              <div
                                style={{ width: "inherit", height: "inherit" }}
                              >
                                Component {item.name} not found.
                              </div>
                            </div>
                          );
                        })}
                      </ResponsiveGridLayout>
                      {(items.components.length && (
                        <div className="add-plus-icon">
                          <button
                            className="btn btn-primary me-2 "
                            onClick={() => modelHandler(index)}
                          >
                            <PlusCircle className="me-add" /> Add Components
                          </button>
                        </div>
                      )) ||
                        ""}
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="content">
              <p>
                {translation?.no_permission ||
                  "You do not have permission to view this page."}
              </p>
            </div>
          )}
        </div>
        {/* <LineChartModal/> */}
      </div>
    );
  };

  return <>{renderHandler()}</>;
};

export default Dashboard;
